import { motion, useReducedMotion } from "framer-motion";

interface TestimonialInterstitialProps {
  quote: string;
  name: string;
}

export function TestimonialInterstitial({
  quote,
  name,
}: TestimonialInterstitialProps) {
  const shouldReduceMotion = useReducedMotion();
  const words = quote.split(" ");

  const containerVariants = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.03, // Very fast cascade
      },
    },
  };

  const wordVariants = {
    hidden: { opacity: 0, filter: "blur(4px)", y: 2 },
    visible: {
      opacity: 1,
      filter: "blur(0px)",
      y: 0,
      transition: {
        duration: 0.2,
        ease: "easeOut" as const,
      },
    },
  };

  return (
    <div className="py-12 px-8 bg-accent/5 dark:bg-accent/10 text-center relative overflow-hidden">
      <div className="max-w-3xl mx-auto relative z-10 flex flex-col items-center">
        {/* Large premium quote mark icon */}
        <span className="text-6xl font-serif text-accent/20 select-none leading-none -mb-4">
          &ldquo;
        </span>

        {shouldReduceMotion ? (
          <p className="text-lg md:text-xl text-foreground leading-relaxed italic mb-4 max-w-[65ch]">
            {quote}
          </p>
        ) : (
          <motion.p
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-10% 0px" }}
            className="text-lg md:text-xl text-foreground leading-relaxed italic mb-4 max-w-[65ch]"
          >
            {words.map((word, i) => (
              <motion.span
                key={i}
                variants={wordVariants}
                className="inline-block mr-1.5"
              >
                {word}
              </motion.span>
            ))}
          </motion.p>
        )}

        <span className="text-sm font-semibold text-accent">{name}</span>
      </div>
    </div>
  );
}

